module.exports = __webpack_public_path__ + "static/cloud-1-26db45b4748f82cd2cccb7562f282ca5.png";